"use client";
import { Button, Spinner, Tooltip } from "@nextui-org/react";
import { useDisclosure } from "@nextui-org/react";
import AuthorModal from "@/app/components/AuthorModal";
import { useSession } from "next-auth/react";
import { useState, useEffect } from "react";
import { signIn } from "next-auth/react";
import { Alert } from "@/app/components/Alert";
import { useRouter } from "next13-progressbar";
import { IoLinkOutline } from "react-icons/io5";

export const AssociateProfiles = ({ label, authorId, isVerified }) => {
  const router = useRouter();
  const [showAssociateButton, setShowAssociateButton] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const { status, data } = useSession();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [authorData, setAuthorData] = useState([]);

  const joinProfiles = async (mainProfile, profiles) => {
    try {
      const NEXT_PUBLIC_REST_URL = process.env.NEXT_PUBLIC_REST_URL;
      await fetch(`${NEXT_PUBLIC_REST_URL}authors/join-profiles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Indicando el tipo de contenido enviado
        },
        body: JSON.stringify({
          mainProfile,
          profiles,
        }),
      }).then((res) => {
        setShowAlert(true);
        if (res.status === 201) {
          setType("success");
          setMessageAlert("Perfil asociado correctamente.\nRedirigiendo...");
          setShowAssociateButton(false);
          setTimeout(() => {
            router.push(`/author/${mainProfile}`);
          }, 2000);
          return res.json();
        } else {
          setType("error");
          setShowAssociateButton(false);
          setMessageAlert("Error al asociar el perfil.");
          throw new Error("Error al enviar los datos");
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickVerificateButton = () => {
    if (status === "authenticated") {
      if (!data.user.id) {
        router.push("/register");
        return;
      }
      setLoading(true);
      joinProfiles(data.user.id, [authorId]);
      onOpenChange(false);
    } else if (status === "unauthenticated") {
      signIn("keycloak", { callbackUrl: "/register" });
    }
  };

  useEffect(() => {
    if (status === "loading") return;
    if (isVerified) {
      setShowAssociateButton(false);
      return;
    }
    if (status !== "authenticated") {
      setShowAssociateButton(true);
      return;
    }
    if (status === "authenticated") {
      if (data.user.id === authorId) {
        setShowAssociateButton(false);
      } else {
        setShowAssociateButton(true);
      }
    }
  }, [status, data, authorId, isVerified]);

  const handleDismiss = () => {
    setShowAlert(false); // Esto "destruirá" el Alerta al no renderizarlo más
  };

  const fetchAuthorData = async (authorId) => {
    const NEXT_PUBLIC_GRAPHQL_URL = process.env.NEXT_PUBLIC_GRAPHQL_URL;
    const response = await fetch(NEXT_PUBLIC_GRAPHQL_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `
          query GetAuthor($id: String!) {
            author(id: $id) {
              authorId
              label
              bio
              image_1
              documents {
                title
                publicationYear
              }
              patents {
                title
                registrationDate
                approvalDate
              }
              projects {
                title
                startDate
                endDate
              }
            }
          }
        `,
        variables: {
          id: authorId,
        },
      }),
    });

    const responseBody = await response.json();
    setAuthorData([responseBody.data.author]);
    return responseBody.data.author;
  };

  useEffect(() => {
    fetchAuthorData(authorId);
  }, [authorId]);

  return (
    <div className="mt-5">
      <Alert
        message={messageAlert}
        type={type}
        isVisible={showAlert}
        onDismiss={handleDismiss}
      />
      {showAssociateButton &&
        (loading ? (
          <div>
            <p className="text-tiny">
              Asociando este perfil a su cuenta de REDI.
            </p>
            <Spinner />
          </div>
        ) : (
          <div className="">
            <Tooltip
              content={
                <TooltipContent
                  title={`¿Eres ${label}?`}
                  content="Puedes asociar este perfil con tu cuenta en REDI."
                />
              }
              showArrow
            >
              <Button
                variant="bordered"
                color="primary"
                onPress={onOpen}
                endContent={<IoLinkOutline />}
              >
                Asociarme a este perfil
              </Button>
            </Tooltip>
          </div>
        ))}

      <AuthorModal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        authors={authorData}
        handleClickVerificateButton={handleClickVerificateButton}
      />
    </div>
  );
};
const TooltipContent = ({ title, content }) => {
  return (
    <div className="flex flex-col justify-center items-center text-small">
      <h3 className="font-bold text-blue-900">{title}</h3>
      <p>{content}</p>
    </div>
  );
};
